module.exports = __webpack_public_path__ + "img/persil_plat_md.655c23c8.jpg";